import { useAuth as useAuthContext } from "@/contexts/AuthContext";

export const useAuth = () => {
  const { user, isLoading, setNewPassword, signIn, signUp, confirmSignUp, forgotPassword, resetPassword, changePassword, resendCode, setPendingEmail, update } =
    useAuthContext();

  const isAuthenticated = !!user;

  return {
    user,
    isLoading,
    isAuthenticated,
    setNewPassword,
    signIn,
    signUp,
    confirmSignUp,
    forgotPassword,
    resendCode,
    resetPassword,
    changePassword,
    setPendingEmail,
    update,
  };
};
